import React from 'react';
import ModuleDetailPage from './ModuleDetailPage';

const POSSystemPage = () => <ModuleDetailPage moduleId="pos-system" />;

export default POSSystemPage;
